const CAMPAIGN_ID = "345261";

const OPEN_BUTTON_ID = "POP_CONVERT_BUTTON";
const CLOSE_BUTTON_ID = "CLOSE_POP_CONVERT_FLOATER";
const POP_FLOATER_ID = "POP_FLOATER";


((window, document) => {

  function init() {
    const params = new URLSearchParams(window.location.search);
    const isTestTrue = params.get("test") === "true";

    const closeButton = document.getElementById(CLOSE_BUTTON_ID);

    closeButton.addEventListener("click", () => {
      document.getElementById(POP_FLOATER_ID).remove();
    })

    const openZendeskNode = document.getElementById("open-zendesk-chat");

    openZendeskNode.addEventListener("click", openZendesk);

    openPopConvertCampaign(CAMPAIGN_ID)

  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

   function openPopConvertCampaign(campaignId) {
      const div = document.querySelectorAll(".pop-convert-floater");

      if(div) {
        const node = Array.from(div)[0];
        node.classList.add("visible");
        console.log("Node classlist", node.classList);
      }
        
    
      
    }

    function openZendesk() {
           try {
        // Messaging widget
        if (typeof zE === 'function') {
          try {
            zE('messenger', 'open');
            return;
          } catch (e) {}

          try {
            zE('webWidget', 'open');
            return;
          } catch (e) {}
        }

        console.warn('Zendesk widget API not available yet.');
      } catch (err) {
        console.error('Failed to open Zendesk widget:', err);
      }
    }

})(window, document);